<template>
  <v-badge 
  color="red" 
  v-if="this.count.length > 0"
  :content="this.count.length">
  </v-badge>
</template>

<script>
import { mapState } from 'vuex'

export default({
    computed: {
        ...mapState({
            count : (state) =>  state.documents.route_pending_documents
        })
    }
})
</script>
